import React, { useEffect, useState } from "react";
import { Box, Drawer, useMediaQuery, useTheme } from "@mui/material";
import AdminSidebar from "./AdminSidebar";
import AdminTopbar from "./AdminTopbar";
import { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED } from "./sidebarConstants";
import { Outlet, useLocation } from "react-router-dom";
import { NotificationProvider } from "../../context/NotificationContext";

const TOPBAR_HEIGHT = 68;

export default function AdminLayout() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const sidebarWidth = isDesktop ? (collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED) : 0;
  const contentMarginLeft = isDesktop ? sidebarWidth : 0;

  useEffect(() => {
    if (!isDesktop) {
      setMobileOpen(false);
    }
  }, [location.pathname, isDesktop]);

  const handleToggleSidebar = () => {
    if (isDesktop) {
      setCollapsed((prev) => !prev);
    } else {
      setMobileOpen((prev) => !prev);
    }
  };

  const handleCloseMobile = () => setMobileOpen(false);

  return (
    <NotificationProvider>
    <Box
      sx={{
        minHeight: "100dvh",
        background: theme.admin?.layout?.background || theme.palette.background.default,
      }}
    >
      <Box
        sx={{
          display: { xs: "none", md: "block" },
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          width: `${collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED}px`,
          zIndex: 1300,
        }}
      >
        <AdminSidebar collapsed={collapsed} />
      </Box>

      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleCloseMobile}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: { xs: "min(280px, 88vw)", sm: 280 },
            maxWidth: "92vw",
            boxSizing: "border-box",
            bgcolor: "transparent",
            borderRight: "none",
            backgroundImage: "none",
          },
        }}
      >
        <AdminSidebar collapsed={false} onNavClick={handleCloseMobile} />
      </Drawer>

      <Box
        sx={{
          minWidth: 0,
          ml: { xs: 0, md: `${contentMarginLeft}px` },
          pt: `${TOPBAR_HEIGHT}px`,
          pb: 2,
          transition: theme.transitions.create(["margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <AdminTopbar leftOffset={isDesktop ? sidebarWidth : 0} onToggleSidebar={handleToggleSidebar} />
        <Outlet />
      </Box>
    </Box>
    </NotificationProvider>
  );
}
